import React from 'react';
import { FaPhoneAlt } from 'react-icons/fa';
import Classes from './PageLayout.module.css';
import { SITE } from '../../../data/siteConfig';
import { Helmet } from 'react-helmet-async';
import { heroPreload, srcSetFor } from '../../../data/photos';

// Shell for content pages (services, service areas, 404): photo hero + body.
// Global nav / footer come from SiteLayout.
export default function PageLayout({ title, subtitle, image = '/assets/images/1.webp', children }) {
    return (
        <main>
            <Helmet link={[heroPreload(image)]} />
            <header className={Classes.header}>
                <img src={image} srcSet={srcSetFor(image)} sizes="100vw" alt="" aria-hidden="true" className={Classes.heroImg} fetchpriority="high" />
                <div className={`container ${Classes.heroInner}`}>
                    <h1>{title}</h1>
                    {subtitle && <p className={Classes.subtitle}>{subtitle}</p>}
                    <CtaButtons />
                </div>
            </header>

            <div className={`container ${Classes.body}`}>{children}</div>
        </main>
    );
}

export function CtaButtons() {
    return (
        <div className={Classes.buttons}>
            <a href={SITE.bookingUrl} target="_blank" rel="noopener noreferrer" className="btn btn-light">
                Book an Appointment
            </a>
            <a href={`tel:${SITE.phoneE164}`} className="btn btn-outline-light">
                <FaPhoneAlt /> {SITE.phone}
            </a>
        </div>
    );
}

// Closing call-to-action panel at the bottom of content pages.
export function CtaBox({ title, text, image }) {
    return (
        <section className={`${Classes.ctaBox} ${image ? Classes.ctaBoxPhoto : ''}`}>
            {image && <img src={image} srcSet={srcSetFor(image)} sizes="(max-width: 1340px) 100vw, 1260px" alt="" aria-hidden="true" loading="lazy" className={Classes.ctaImg} />}
            <h2>{title}</h2>
            <p>{text}</p>
            <CtaButtons />
        </section>
    );
}
